export enum MODAL_TYPES {
  WRONG_NETWORK_MODAL = 'WRONG_NETWORK_MODAL',
  BONDS_REDEEM_MODAL = 'BONDS_REDEEM_MODAL',
  BONDS_STAKE_MODAL = 'BONDS_STAKE_MODAL',
  BONDS_UNSTAKE_MODAL = 'BONDS_UNSTAKE_MODAL',
  BONDS_DISCLAIMER_MODAL = 'BONDS_DISCLAIMER_MODAL',
}

export const INITIAL_MODAL_STATE = {
  current: null,
  props: null,
};
